import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { combineLatest, take, tap } from 'rxjs';

import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { ISucceededSlipResult } from '../../../../betplacement/models';
import { systemBetBankerCount, systemBetTypeStakeSelectorFactory } from '../../../../system-bet/selectors';
import SystemBetTypesCalculatorService from '../../../../system-bet/services/types/system-bet-types-calculator.service';

@Component({
    selector: 'bs-digital-linear-result-system-wrapper',
    templateUrl: './linear-result-system-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearResultSystemWrapperComponent implements OnInit {
    @Input() succeededSlip: ISucceededSlipResult;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() inColumn: boolean;

    @HostBinding('class.expanded') expanded = true;

    isEpcot = false;
    systemType = BetslipType.System;
    title: string | undefined;

    constructor(
        private store: Store<IBetslipRootState>,
        public epcotConfigService: EpcotConfigService,
        private typesCalculator: SystemBetTypesCalculatorService,
    ) {
        this.isEpcot = this.epcotConfigService.isEnabled(EpcotModule.Betslip);
    }

    ngOnInit(): void {
        const systemBetType$ = this.store.select(systemBetTypeStakeSelectorFactory(this.succeededSlip.systemKey || ''));
        const systemBetBankerCount$ = this.store.select(systemBetBankerCount);

        combineLatest([systemBetType$, systemBetBankerCount$])
            .pipe(
                take(1),
                tap(([type, bankerCount]) => {
                    this.title = this.typesCalculator.getTypeName(type?.betCount || 0, bankerCount, type?.slipType.key || '');
                }),
            )
            .subscribe();
    }
}
